export const qk = {
  customers: (filters?: Record<string, unknown>) => ['customers', filters ?? {}] as const,
  customer: (id: string) => ['customers', id] as const,
  kycQueue: ['kyc', 'queue'] as const,
  transfers: (filters?: Record<string, unknown>) => ['transfers', filters ?? {}] as const,
  transfer: (id: string) => ['transfers', id] as const,
  rates: ['rates'] as const,
  fees: ['fees'] as const,
  staff: ['staff'] as const,
  audit: (filters?: Record<string, unknown>) => ['audit', filters ?? {}] as const,
  settings: ['settings'] as const,
  promoCodes: (search?: string) => ['promoCodes', search ?? ''] as const,
};
